import React, { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { isEqual } from 'lodash';

import log from "Utils/logger";

import CONFIG from "Config";

import * as SubscriptionActions from "Flux/subscriptions/actions";

const useUpdateSubscription = ( ) => {
  console.log ("*** ** updateSubscription: useUpdateSubscription hook triggered ");

  const isUpdatingSubscriptionsRef = useRef(false);
  const hasUpdatedSubscriptionsRef = useRef(false);

  const dispatch = useDispatch();
  const storedSubscriptions = useSelector(state => state.subscriptions.availSubscriptionPlans);
  const user = useSelector(state => state.authentication.user);

  const updateSubscription = async ( subscriptionID ) => {

    console.log("*** ** updateSubscription: useUpdateSubscription FUNCTION triggered with subscriptionID: ", subscriptionID);
    
    if (!Number.isInteger(subscriptionID) || subscriptionID <= 0) {
      console.log('*** ** updateSubscription: invalid subscriptionID, aborting call.');
      return;
    }
    
    if (isUpdatingSubscriptionsRef.current) {
      console.log('*** ** updateSubscription: useEffect - EXITING isUpdatingSubscriptionsRef.current is true, skipping update.');
      return;
    }
    
    console.log ("*** ** updateSubscription: updateSubscription function triggered with subscriptionID: ", subscriptionID);
    isUpdatingSubscriptionsRef.current = true;
    
    try {

      const result = await dispatch(SubscriptionActions.updateShopperSubscriptionPlan(subscriptionID));


      console.log('*** ** updateSubscription: storedSubscriptions: ', storedSubscriptions)
      console.log ('*** ** updateSubscription: result: ', result);
      

      const newSubscriptions = result.data.data.map(subscription => {
        const {
          id,
          sponsor,
          product,
          name,
          amount,
          value_prop,
          charge_period,
          charge_method,
          charge_details,
          available,
          selected,
          shopper_subscribed,
          features,
        } = subscription;
      
        return {
          subscriptionID: id,
          subscriptionSponsor: sponsor,
          subscriptionProduct: product,
          subscriptionName: name,
          subscriptionAmount: amount,
          subscriptionValueProp: value_prop,
          subscriptionPeriod: charge_period,
          subscriptionChargeMethod: charge_method,
          subscriptionChargeDetails: charge_details,
          subscriptionAvailable: available,
          subscriptionOptionSelected: selected,
          shopperSubscribed: shopper_subscribed,
          subscriptionPlanFeatures: features,
        };
      });
      

      console.log('*** ** updateSubscription: newSubscriptions.keys.length:',Object.keys( newSubscriptions).length)
      console.log('*** ** updateSubscription: storedSubscriptions.keys.length:', Object.keys(storedSubscriptions).length)

      //console.log('*** ** updateSubscription: newSubscriptions.length:',( newSubscriptions).length)
      //console.log('*** ** updateSubscription: storedSubscriptions.length:', (storedSubscriptions).length)

      console.log('*** ** updateSubscription: newSubscriptions: ', newSubscriptions);
      console.log('*** ** updateSubscription: storedSubscriptions: ', storedSubscriptions);

      //*****MAYBE NOT NEEDED*****
      if (shouldUpdateStore(newSubscriptions, storedSubscriptions)) {
        console.log('*** ** updateSubscription: newSubscriptions and storedSubscriptions are different');
        console.log('*** ** updateSubscription: newSubscriptions.length:',( newSubscriptions).length)
        console.log('*** ** updateSubscription: storedSubscriptions.length:', (storedSubscriptions).length)
          console.log('*** ** updateSubscription: DISPATCH SET stores with newSubscriptions: ', newSubscriptions);
          //dispatch(SubscriptionActions.setAvailableSubscriptionPlans(newSubscriptions));

          const updatedPlans = storedSubscriptions.map(existingPlan => {
            const match = newSubscriptions.find(p => p.subscriptionID === existingPlan.subscriptionID);
            const newSubscribed = match?.shopperSubscribed === true;
          
            // ✅ Return existing reference if no change
            if (existingPlan.shopperSubscribed === newSubscribed) {
              return existingPlan;
            }
          
            return {
              ...existingPlan,
              shopperSubscribed: newSubscribed,
            };
          });

          dispatch(SubscriptionActions.setAvailableSubscriptionPlans(updatedPlans));
        
      }
    } catch (exception) {
      console.log(exception);
      log({
        event: "System-Error",
        source: "FetchStores",
        info: exception,
        ...exception,
      });
    } finally {

      isUpdatingSubscriptionsRef.current = false;
      hasUpdatedSubscriptionsRef.current = true;
    }
  };

  function shouldUpdateStore(newSubscriptions, storedSubscriptions) {
    const newMap = new Map(newSubscriptions.map(plan => [plan.subscriptionID, plan.shopperSubscribed]));

    let foundDifference = false;

    //remove this table before prod. Used to check if subscriptions updating correctly.
/*     console.table(
      storedSubscriptions.map(plan => ({
        LogSource: '*** ** updateSubscription:', // ✅ searchable in DevTools filter
        ID: plan.subscriptionID,
        Stored: plan.shopperSubscribed,
        Incoming: newMap.get(plan.subscriptionID),
        Changed: plan.shopperSubscribed !== newMap.get(plan.subscriptionID)
      }))
    ); */
  
    for (const plan of storedSubscriptions) {
      const newSubscribed = newMap.get(plan.subscriptionID);
      const oldSubscribed = plan.shopperSubscribed;
  
      if (newSubscribed !== oldSubscribed) {
        foundDifference = true;
      }
    }
  
    return foundDifference;
  
  }
  
  return { updateSubscription };
};

export default useUpdateSubscription;



  // useEffect(() => {
  //   console.log('*** ** updateSubscription: useEffect - triggered on load to initialise updateSubscription with subscriptionID: ', subscriptionID);

  //   if (!Number.isInteger(subscriptionID) || subscriptionID <= 0) {
  //     console.log('*** ** updateSubscription: useEffect - Invalid subscriptionID, skipping update.');
  //     return;
  //   }
  //   console.log('*** ** updateSubscription: useEffect - isUpdatingSubscriptionsRef.current: ', isUpdatingSubscriptionsRef.current);
  //   console.log('*** ** updateSubscription: useEffect - hasUpdatedSubscriptionsRef.current: ', hasUpdatedSubscriptionsRef.current);
  //   console.log('*** ** updateSubscription: useEffect - storedSubscriptions: ', storedSubscriptions);
    
  //   if (isUpdatingSubscriptionsRef.current || hasUpdatedSubscriptionsRef.current) {
  //     console.log('*** ** updateSubscription: useEffect - EXITING isUpdatingSubscriptionsRef.current or hasUpdatedSubscriptionsRef.current is true, skipping update.');
  //     return;
  //   }

  //   console.log('*** ** updateSubscription: useEffect - calling updateSubscription with subscriptionID: ', subscriptionID);
  //   updateSubscription( subscriptionID );
    
    
  // }, [ subscriptionID ]);




/*   useEffect(() => {
    if ( user
      && storedSubscriptions.length > 0
      && !isUpdatingSubscriptionsRef.current
      && hasUpdatedSubscriptionsRef.current
    ) {
        console.log('*** ** updateSubscription: useEffect - user available: hasUpdatedSubscriptionsRef.current - lets fetchFavoriteShops + fetchShopperBoostProfile')
        console.log ('*** ** updateSubscription: useEffect - hasUpdatedSubscriptionsRef.current - lets fetchFavoriteShops');
        fetchFavoriteShops();

    } 
    
    if (  storedSubscriptions.length > 0
        && !isUpdatingSubscriptionsRef.current
        && hasUpdatedSubscriptionsRef.current
      ){
       console.log ('*** ** updateSubscription: useEffect - hasUpdatedSubscriptionsRef.current - lets fetchStoreBoostProfiles');
       fetchStoreBoostProfiles();
    }
    
  }, [hasUpdatedSubscriptionsRef.current]); */

  //return { isUpdatingSubscriptionsRef.current, hasUpdatedStores, updateSubscription };
//   return { updateSubscription };
// };

// export default useUpdateSubscription;
